import React, { useCallback } from 'react';

import CheckIcon from '@repo/ui/components/Icon/v2/CheckIcon';
import {
  Tooltip,
  TooltipAlignment,
  TooltipPlacement,
} from '@repo/ui/components/Tooltip';

import { DropdownOptionWrapper } from './styles';
import { DropdownOptionProps } from './types';

const DropdownOption: React.FC<DropdownOptionProps> = ({
  option,
  optionCustomStyles,
  small = false,
  compact = false,
  isActive,
  onClick,
  onMouseEnter,
  onMouseLeave,
  renderItem,
}) => {
  const handleClick = useCallback(() => {
    if (onClick && !option.unselectable) {
      onClick(option);
    }
  }, [onClick, option]);

  return (
    <Tooltip
      align={TooltipAlignment.Center}
      placement={TooltipPlacement.Top}
      text={option.tooltipText}
    >
      <DropdownOptionWrapper
        compact={compact}
        customStyles={optionCustomStyles || {}}
        isActive={isActive}
        isCustomRender={!!renderItem}
        selectable={!option.unselectable}
        sizeString={
          option.size
            ? `${option.size.x} × ${option.size.y} ${option.size.unit}`
            : ''
        }
        small={small}
        onClick={handleClick}
        onMouseEnter={() => onMouseEnter?.(option)}
        onMouseLeave={() => onMouseLeave?.(option)}
      >
        {renderItem ? renderItem(option) : option.label}
        {!renderItem && isActive && <CheckIcon height="12px" />}
      </DropdownOptionWrapper>
    </Tooltip>
  );
};

export default React.memo(DropdownOption);
